export const queryKeys = {
  REGION_ACCIDENT_VIEW: "region-accident-view",
  ORGANIZATION_PROBLEM_CLASS: "organization-problem-class",
}